/**
 * What a write-up can be in.
 *
 * Deliberately not the transcription list: `multi` is a mode for *hearing*
 * several languages at once and means nothing as an answer to "what should
 * this be written in".
 *
 * Shared because the same list is offered in two places that belong to
 * different owners — notes and commitments are each person's own, and
 * knowledge is the workspace's (PRD 48).
 */
export const WRITTEN_IN: Array<[string, string]> = [
  ['auto', 'The language it was spoken in'],
  ['en', 'English'],
  ['ru', 'Russian'],
  ['de', 'German'],
  ['fr', 'French'],
  ['es', 'Spanish'],
  ['pl', 'Polish'],
  ['uk', 'Ukrainian'],
  ['cs', 'Czech'],
];

/** Every language a page can be shown in, by name — the list above, and the few more a person's setting may hold. */
const NAMES: Record<string, string> = {
  ...Object.fromEntries(WRITTEN_IN.filter(([code]) => code !== 'auto')),
  pt: 'Portuguese',
  it: 'Italian',
  nl: 'Dutch',
  tr: 'Turkish',
};

/** "Russian" for `ru`; a code nobody named is shown as it is. */
export const languageName = (code: string): string => NAMES[code] ?? code;
